import React from 'react';
import AnalysisDefaultsPanel from './AnalysisDefaultsPanel';
import { useAuth } from '../../context/AuthContext';
import AnalysisMethodsPanel from '../AnalysisMethodsPanel';
import { Link } from 'react-router';
import DefaultNewDeviceEntityPathPanel from './DefaultNewDeviceEntityPathPanel';
import ColourPalettePanel from './ColourPalettePanel';
import EntityPathOptionsPanel from './EntityPathOptionsPanel';
import { useSystemEntityPathOptions } from '../../hooks/useSystemEntityPathOptions';

// Plan 83: top-level admin page for system-level configuration. Scaffolded
// with section headings so future panels (e.g. feature flags, dispatcher
// settings) can drop in without reshuffling routing.
const SystemPage: React.FC = () => {
  const { hasPermission } = useAuth();
  const entityPathOptions = useSystemEntityPathOptions();

  return (
    <div className="container mx-auto p-6 space-y-8">
      <h1 className="text-2xl font-bold">System</h1>
      <p className="text-sm text-gray-600">
        <Link to="/system/patterns" className="text-blue-700 underline" title="Explore the administrator control patterns using synthetic data.">
          Explore control patterns
        </Link>
      </p>
      <section aria-labelledby="system-palette-heading">
        <h2 id="system-palette-heading" className="text-xl font-semibold mb-3">Colour palette</h2>
        <ColourPalettePanel />
      </section>
      <section aria-labelledby="system-defaults-heading">
        <h2 id="system-defaults-heading" className="text-xl font-semibold mb-3">New Device Defaults</h2>
        <DefaultNewDeviceEntityPathPanel entityPathOptions={entityPathOptions} />
      </section>
      <section aria-labelledby="system-analysis-defaults-heading">
        <h2 id="system-analysis-defaults-heading" className="text-xl font-semibold mb-3">Analysis defaults</h2>
        <AnalysisDefaultsPanel />
      </section>
      <section aria-labelledby="system-paths-heading">
        <h2 id="system-paths-heading" className="text-xl font-semibold mb-3">Entity Path Options</h2>
        <p className="text-sm text-gray-600 mb-3">
          Allowed org-scope paths offered in the device edit dropdown. Removing
          a path is blocked while any device still uses it.
        </p>
        <EntityPathOptionsPanel entityPathOptions={entityPathOptions} />
      </section>
      {hasPermission('system_admin') && hasPermission('manage_analysis_runs') && (
        <section aria-labelledby="system-analysis-heading">
          <h2 id="system-analysis-heading" className="text-xl font-semibold mb-3">Analysis Methods</h2>
          <AnalysisMethodsPanel />
        </section>
      )}
    </div>
  );
};

export default SystemPage;
